import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
// import notify from '../../Notifications/ToastifyActions';
import notify from '../../../Notifications/ToastifyActions';

function UpdateAccountUserRolesService(token, data) {
    
    // id in productDetails is either a field called asin or a field called integerId
    return axios.post(`${CURRENT_API_URL}/account/updateAccountUserRoles`, data, {
        
        headers: {
            'Authorization': token,
        }
    }).then().
        then(res => {
        notify.NotifySuccess("The role of the selected user has been updated successfully.");
            return res.data;
        }).catch(error => {  
            console.log(error)            
            notify.NotifyError("An error occurred while chanaging user role, please try again later.");
            return false;
        
        });
}
export  default UpdateAccountUserRolesService